<template>
    <van-popup class="my-vip-pay-pop-box" position="bottom" :value="showVipPayPop" @click-overlay="clickClose">
        <div class="my-vip-pay-pop">
            <div class="my-vbp-title">
                <div class="title2">
                    <p>此功能为终身会员专享特权，</p>
                    <p>同时您将享受其它十项<span @click="clickVip">终身免费服务</span></p>
                </div>
            </div>
            <div class="my-vbp-text"><span>￥</span><span class="number1">{{vipProductData["pay_40002"] ? vipProductData["pay_40002"].price:''}}</span></div>
            <div class="my-vbp-text sub"><del class="number2">原价￥{{vipProductData["pay_40002"] ? vipProductData["pay_40002"].rate_price:''}}</del></div>
            <div class="my-vbp-button" @click="clickUse">使用会员特权</div>
        </div>
    </van-popup>
</template>

<script>
import { CONFIG } from '../../modules/config';
import { DOM } from '../../modules/dom';
import { SCHEME } from '../../modules/utils';
export default {
    name: 'VantVipPayPop',
    computed: {
        userData() {
            return this.$store.state.userData;
        },
        vipProductData() {
            return this.$store.state.pay.vipProductData;
        },
        showVipPayPop() {
            return this.$store.state.user.showVipPayPop;
        }
    },
    data() {
        return {
        }
    },
    methods: {
        clickClose() {
            this.$store.state.user.showVipPayPop = false;
        },
        clickVip() {
            this.$store.state.user.showVipPayPop = false;
            // this.$store.state.user.curVipPayType = this.userData.donate == 1 ? 3 : 2;
            this.$store.state.user.showMyVip = true;
            var me = this;
            setTimeout(() => {
                me.$bus.emit('initMyVipPage');
            }, 20);

            var curPath = this.$router.history.current.path;
            if(curPath.indexOf('report') != -1) {
                // DOM.hideParentPageByClassName('report-page');
            }else if(curPath.indexOf('nature') != -1) {
                DOM.hideParentPageByClassName('nature-page');
            }
        },
        clickUse() {
            var me = this,
                pData = this.vipProductData["pay_40002"],
                curPath = this.$router.history.current.path,
                detailInfo = this.$store.state.detail.personInfo;
            // console.error('clickUse------', curPath, pData, detailInfo);
            // return;
            if(curPath.indexOf('embedded') != -1) {
                SCHEME.createAppOrder(pData.pid, detailInfo.id);
                // 支付成功和失败的回调:::app端的回调函数
                window.appFunc = {};
                window.appFunc.reportPaySucCb = function(data) {
                    console.log('reportPaySucCb::::::::', data)
                    // data = JSON.stringify(data);
                    if(detailInfo) {
                        me.$store.dispatch('report/updateReportInfo', data.baziId);
                    }
                    // 隐藏支付弹框,显示成功弹框
                    me.$store.state.report.showVipBtn = false;
                    me.$store.state.user.showVipPayPop = false;
                    me.$store.state.user.showVipSucPop = true;
                    me.$set(me.$store.state.userData.info, 'vip', 1);
                }
                window.appFunc.reportPayFailCb = function() {
                    console.error("支付失败");
                    // me.$toast('支付失败,请稍后再尝试~')
                }
                return;
            }

            this.$store.dispatch('pay/createPayOrder', {
                params: {
                    pid: pData.pid,
                    ptype: pData.payType[2],
                    discount: CONFIG.vip_discount
                },
                mixParams: {
                    pid: pData.pid,
                    product_name: pData.title,
                    price: pData.price,
                    from: 'vip_popup',
                },
                sucCb: function() {
                    console.log('支付VIP成功');
                    // 更新数据
                    if(detailInfo) {
                        if(curPath.indexOf('report') != -1) {
                            me.$store.dispatch('report/updateReportInfo', detailInfo.id);
                        }else if(curPath.indexOf('nature') != -1) {
                            me.$store.dispatch('report/getAiCharacter', {
                                detailInfo: detailInfo
                            });
                        }
                    }
                    // 隐藏支付弹框,显示成功弹框
                    me.$store.state.user.showVipPayPop = false;
                    me.$store.state.user.showVipSucPop = true;
                },
                failCb: function() {
                    console.error('支付失败----')
                    // me.$toast('支付失败,请稍后再尝试~')
                }
            });
        }
    }
}
</script>